import faker from 'faker'

const category = () => ({
  id: faker.datatype.uuid(),
  value: faker.animal.type(),
})
export const getCategory = async () => new Array(12).fill('').map(category)
